import { useSyncExternalStore } from 'react';
import type { FlagSnapshot } from '../store/types';
import { useFeatureFlagStore } from './FeatureFlagContext';

export function useFlagSnapshot(): FlagSnapshot {
  const store = useFeatureFlagStore();
  return useSyncExternalStore(store.subscribe, store.getSnapshot);
}
